import React, { useState } from "react";
import logo from "../../assets/image/logo_footer.png";
import fb from "../../assets/image/facebook.png";
import twitter from "../../assets/image/twitter.png";
import insta from "../../assets/image/instagram.png";
import youtube from "../../assets/image/youtube.png";
import "./footer.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Footer = () => {
  let baseURL;

 
    baseURL = process.env.REACT_APP_API_ENDPOINT;

  const [email, setEmail] = useState("");


  const handleSubscribe = async () => {
    if (!email) {
      toast.warn("Please enter an email address.");
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/api/v1/subscribe/createSubscribe`, {
        email,
      });

      if (response.status === 201) {
        toast.success("Subscribed successfully!");
        setEmail(""); // clear input
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Failed to subscribe. Try again."
      );
    }
  };

  return (
    <>
      <footer className="">
        <div className="container">
          <div className="default-padding">
            <div className="row gy-5">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="footer_about wow animate__animated animate__fadeInLeft">
                  <img src={logo} alt="" />
                  <p>
                    Classhila Education Private Limited 19/3RT <br />MIGH Vijayanagar
                    Colony Hyderabad-500057
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <div className="footer_link wow animate__animated animate__fadeInUp">
                <h4>Quick Links</h4>
                <ul>
                  <li>
                    <Link to={"/about-us"}>About Us</Link>
                  </li>
                  <li>
                    <Link to={"/mentor"}>Our Mentors</Link>
                  </li>
                  <li>
                    <Link to={"/privacy-policy"}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={"/terms-conditions"}>Terms Conditions</Link>
                  </li>
                  <li>
                    <Link to={"/faq"}>FAQs</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <div className="footer_link wow animate__animated animate__fadeInUp">
                <h4>Contact Us</h4>
                <ul>
                  <li>
                    <Link to={"#"}>+91 9553460456</Link>
                  </li>
                  <li>
                    <Link to={"#"}>+91 8333812323</Link>
                  </li>
                  <li>
                    <Link to={"#"}>Support@classhila.com</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6">
              <div className="footer_address wow animate__animated animate__fadeInUp">
                <h4>Subscribe for more useful updates</h4>
                <div className="group_email">
                  <input
                    type="text"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button className="btn_secondary" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                </div>
                <div className="share_on_footer">
                  <p>
                    <Link>
                      <img src={fb} alt="facebook" />
                    </Link>
                    <Link>
                      <img src={insta} alt="instagram" />
                    </Link>
                    <Link>
                      <img src={twitter} alt="twitter" />
                    </Link>
                    <Link>
                      <img src={youtube} alt="youtube" />
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer_bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 wow animate__animated animate__fadeInLeft">
              <p className=" main_text text-center ">
                Copyright © 2024 Classhila.com All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Footer;
